import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixSite from 'wix-site';
import { insertUser } from "backend/form.jsw";
import { getCountryCode } from "backend/getCountryCode";
import { getUserDetails } from 'public/getUserDetails';
import { fireBIEvent } from 'public/bi-events.js';
import { url as PageURL } from 'wix-location';


let clientId;
let isInserting = false;
$w.onReady(function () {
    fireFromOpenBI();
    pageEvents();
});

setTimeout(() => {
    $w('#customElement1').setAttribute('ready', true);
}, 2000)

function pageEvents() {
    $w('#customElement1').on('myEvent', ({ detail: { data } }) => {
        clientId = data
    });

    let countryCode
    let uuid
    asyncFunctions()

    async function asyncFunctions() {
        countryCode = await getCountryCode();
        uuid = await getUserUuid();
        $w('#getStartedBtn').enable()
    }

    $w('#getStartedBtn').onClick(async () => {
        console.log('get started was clicked');
        const isValid = validateRequiredFields();
        if (!isValid) {
            fireEvent('', false);
            return
        }
        if (isInserting) return
        isInserting = true;

        let userInformation = getInputFields();

        const toInsert = {
            ...userInformation,
            "source": "Enterprise LP 2022",
            "language": wixSite.language,
            "inputReferral": wixWindow.referrer,
            "clientId": clientId,
            "countryCode": countryCode,
            "uuid": uuid,
        }
        const response = await insertUser(toInsert);
        fireEvent(response._id, true);
        isInserting = false;
        if (response._id) {
            wixLocation.to("/thank-you");
        }
    });

    $w('#firstNameInput').onChange(() => {
        $w('#firstNameInput').style.borderColor = 'rgb(255, 255, 255)';
    });

    $w('#lastNameInput').onChange(() => {
        $w('#lastNameInput').style.borderColor = 'rgb(255, 255, 255)';
    });

    $w('#emailInput').onChange(() => {
        $w('#emailInput').style.borderColor = 'rgb(255, 255, 255)';
    });

    $w('#checkboxInput').onChange(() => {
        $w('#checkboxInput').style.borderColor = 'rgb(255, 255, 255)';
    });
}

function getInputFields() {
    return {
        "title": $w('#firstNameInput').value,
        "lastName": $w('#lastNameInput').value,
        "company": $w('#companyInput').value,
        "jobTitle": $w('#jubTitleInput').value,
        "businessEmail": $w('#emailInput').value,
        "phoneNumber": $w('#numberInput').value,
        "companySize": $w('#companySizeInput').value,
        "whatWouldYouLikeToDiscuss": $w('#lickToDiscussInput').value,
        "approvePrivacy": $w('#checkboxInput').checked
    }
}

function validateRequiredFields() {
    const requiredFileds = ["firstName", "lastName", "email", "checkbox"];
    let isValid = true;

    for (let index = 0; index < requiredFileds.length; index++) {
        switch (requiredFileds[index]) {
        case "firstName":
            if (!$w('#firstNameInput').value) {
                $w('#firstNameInput').style.borderColor = 'red';
                isValid = false;
            }

            break;
        case "lastName":
            if (!$w('#lastNameInput').value) {
                $w('#lastNameInput').style.borderColor = 'red';
                isValid = false;
            }
            break;
        case "email":
            if (!$w('#emailInput').value) {
                $w('#emailInput').style.borderColor = 'red';
                isValid = false;
            }
            break;
        case "checkbox":
            if (!$w('#checkboxInput').checked) {
                $w('#checkboxInput').style.borderColor = 'red';
                isValid = false;
            }
            break
        }

    }

    return isValid;
}

async function getUserUuid() {
    const userDetails = await getUserDetails();
    return userDetails.payload?.guid;
}

function fireEvent(leadId, isValid) {
    const biFields = {
        button_name: 'get started',
        topic: 'Enterprise form',
        url: PageURL,
        additional_info: 'enterprise main lp',
        formDetailsJson: JSON.stringify(getInputFields()),
        formIsValid: isValid,
        full_url: PageURL,
        leadId: leadId
    }
    fireBIEvent(80, 501, biFields);
}

function fireFromOpenBI() {
    const biFields = {
        evid: 730,
        topic: 'Enterprise form',
        url: PageURL
    };
    fireBIEvent(19, 730, biFields);
}